module.exports = __webpack_public_path__ + "img/2012_S.87bd6990.png";